module.exports = __webpack_public_path__ + "static/media/scroll_gallery_left.88ad03f2.svg";